export default __webpack_public_path__ + "static/media/EditNote.d2139676.svg";